import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import CalendarReminder from 'owa-service/lib/contract/CalendarReminder';

/*
 * Gets the fallback value for reminder option in events and invitaion settings
 */

export function getReminderTime(): CalendarReminder {
    return getFallbackValueIfNull(
        getStore().defaultReminderTime,
        getCalendarConfiguration().DefaultReminderTime
    );
}
